import { Link } from 'react-router-dom';
import { useDeviceDrafts, useNetworkStatus } from '../offline/useOffline';

export default function OfflineBanner() {
  const offline = useNetworkStatus();
  const drafts = useDeviceDrafts();
  const pending = drafts.length;

  if (!offline && !pending) return null;

  return (
    <div className={`border-b px-4 py-2 text-sm ${offline ? 'bg-amber-50 border-amber-200 text-amber-900' : 'bg-blue-50 border-blue-200 text-blue-900'}`}>
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2">
        <span>
          {offline
            ? 'لا يوجد اتصال بالخادم — الفحوصات الجديدة تُحفظ على هذا الجهاز وتُرفع عند عودة الاتصال.'
            : 'الاتصال متاح.'}
          {pending > 0 && ` على الجهاز ${pending} ${pending === 1 ? 'فحص لم يُرفع' : 'فحوصات لم تُرفع'}.`}
        </span>
        {pending > 0 && (
          <Link to="/sync" className="rounded-lg border border-current px-3 py-1 font-semibold">
            فحوصات الجهاز والمزامنة
          </Link>
        )}
      </div>
    </div>
  );
}
